import React, { useContext, useEffect, useRef, useState } from 'react'
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { getCompanyDetailsApi, getStatesData, updateCompanyApi } from '_services';
import { CommonInput, CropModal, CustomSelect } from 'components';
import Tab from 'components/common/Tab'
import ImageCropModal from 'components/ImageModify/ImageCropModal';
import { constant } from 'constants/constant';
import { UserContext } from 'context';
import { companyImageUpload } from 'features';
import { errorSchema, utils } from 'helper';
import useDocumentTitle from 'hooks/useDocumentTitle';
import { Checkbox } from 'pages/User/AddUser';
import { Accordion } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { LuUpload } from "react-icons/lu";
import { useDispatch } from 'react-redux';
import StorageService from 'utils/StorageServices';
import { HiChevronDown } from "react-icons/hi2";
import { AddNewFirmSeriesModal, BranchSeriesInvoiceModal, FirmSeriesModal } from 'modals';
import AddNewSeriesInvoiceModal from 'modals/AddNewSeriesInvoiceModal/AddNewSeriesInvoiceModal';
import { getSingleFirm } from '_services/accountsServices/firmServices';
import FirmProfileDetails from './FirmProfileDetails';
import { getCurrentSeriesNumber } from '_services/accountsServices/firmSeriesServices';
import { FirmDetailsBankSection } from '.';

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

const formObj = {
    payment_voucher: "",
    payment_receipt: "",
    general_expense: "",
    general_receipt: "",
    vehicle_expense: "",
    salary_expense: "",
    emi_expense: "",
    vehicle_document: "",
    purchase_bill: "",
    charge_claim: "",
    pay_claim: ""
}

const FirmDetails = () => {
    const dispatch = useDispatch();
    useDocumentTitle("Company | T360");

    const query = useQuery();
    const navigate = useNavigate();
    const location = useLocation();

    let { id } = useParams();
    const tbn = query.get('tbn') || 1;

    const object = {
        company_id: StorageService.getCompanyId(),
        company: "",
        contact_no: "",
        alt_contact_no: "",
        email_id: "",
        website: "",
        entity_type: '',
        gst_no: "",
        gst_state: {},
        pan_no: "",
        fssai_licence: "",
        address_line1: "",
        address_line2: "",
        state: {},
        city: {},
        pincode: "",
        company_type: []
    }
    const { masterData } = useContext(UserContext);
    const [activeTab, setActiveTab] = useState(Number(tbn));
    const [companyDetails, setCompanyDetails] = useState('')
    const [form, setForm] = useState(object)
    const [entityList, setEntityList] = useState([])

    const [formValue, setFormValue] = useState(formObj);
    const [isOpenInvoiceSeries, setIsOpenInvoiceSeries] = useState(false);
    const [showAddNewInvoiceSeries, setShowAddNewInvoiceSeries] = useState(false);
    const [isSetInvoiceSeries, setIsSetInvoiceSeries] = useState("");
    const [isEditInvoice, setIsEditInvoice] = useState(false);

    const callBackTab = (data) => {
        setActiveTab(data);
        const params = new URLSearchParams(location.search);
        params.set('tbn', data);
        navigate(`${location.pathname}?${params.toString()}`);
    }

    const profileProps = {
        tabList: constant?.firmDetails_Tabs,
        callBackTab: callBackTab,
        activeTab: activeTab
    }

    const [gstTypeList, setGstTypeList] = useState([]);

    useEffect(() => {
        if (masterData) {
            setEntityList(masterData?.entity_type_list?.map((i) => {
                return {
                    label: i?.name,
                    value: i?.id
                }
            }))
            setGstTypeList(masterData?.gst_type_list?.map((el) => {
                return {
                    label: el?.name,
                    value: el?.id
                }
            }))
        }
    }, [masterData])

    const getSingleItem = async () => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                firm_id: id,
            }
            const res = await getSingleFirm(object);
            if (res?.responseCode == 200) {
                let findObject = res?.data?.firm;
                if (findObject?._id) {
                    const details = {
                        firm: findObject?.firm || "",
                        contact_no: findObject?.contact_no || "",
                        alt_contact_no: findObject?.alt_contact_no || "",
                        email_id: findObject?.email_id || "",
                        entity_type: findObject?.entity_type,
                        website: findObject?.website || "",
                        gst_no: findObject?.gst_no || '',
                        gst_type: gstTypeList.find((el) => el?.value === findObject?.gst_type),
                        gst_state: findObject?.gst_state || {},
                        pan_no: findObject?.pan_no || "",
                        fssai_licence: findObject?.fssai_licence || "",
                        address_line1: findObject?.address_line1 || "",
                        address_line2: findObject?.address_line2 || "",
                        state: findObject?.state,
                        city: { ...findObject?.city, name: findObject?.city?.label },
                        pincode: findObject?.pincode || "",
                        firm_type: findObject?.firm_type,
                        logo: findObject?.logo || "",
                        firm_id: findObject?._id,
                    }
                    setForm(details);
                }
            }
        } catch (error) { }
    }

    const getDataLrNumber = async (id) => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                firm_id: id,
            }
            const res = await getCurrentSeriesNumber(object);
            if (res?.responseCode == 200) {
                const vrSeries = res?.data?.vr_series || [];
                const formattedValues = vrSeries?.reduce((acc, item) => {
                    const key = constant.TYPE_KEY_MAP[item?.type];
                    if (key) {
                        acc[key] = `${item?.prefix}-${item?.next_number}`;
                    }
                    return acc;
                }, {});

                setFormValue((prev) => ({
                    ...prev,
                    ...formattedValues,
                }));
            }
        } catch (error) {
            throw error;
        }
    }

    useEffect(() => {
        if (id) {
            getSingleItem();
            getDataLrNumber(id);
        }
    }, [id])

    const handleInvoiceFunctionality = (event, name, type) => {
        event.preventDefault();
        setIsOpenInvoiceSeries({ action: true, name, type });
    };

    let isInvoiceSeriesModalProps = {
        isOpen: isOpenInvoiceSeries,
        closeModal: () => setIsOpenInvoiceSeries({ action: false, name: "" }),
        defaultSeriesData: (data) => setFormValue((s) => ({ ...s, ...data })),
        modalMainClass: "_dashCommon_Modal _mdModal",
        modalTitle: `Select ${utils.specificName(isOpenInvoiceSeries?.name)} series`,
        formData: id,
        submitTitle: "Save",
        nextModal: (e) => setShowAddNewInvoiceSeries(e),
        setIsEditLR: (e) => setIsEditInvoice(e),
        setLrSeries: (e) => setIsSetInvoiceSeries(e),
    };

    let addNewSeriesInvoiceModalProps = {
        isOpen: showAddNewInvoiceSeries,
        closeModal: () => setShowAddNewInvoiceSeries(!showAddNewInvoiceSeries),
        headerPart: false,
        footerPart: false,
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: isEditInvoice?._id ? "Edit New Series" : "Add New Series",
        submitTitle: isEditInvoice?._id ? "Update" : "Save",
        isEditLR: isEditInvoice,
        onSubmit: (e) => setShowAddNewInvoiceSeries(false),
        previosModal: (data) => setIsOpenInvoiceSeries(data),
    };

    return (
        <div className='__profilCmp_main' >
            <div className='__setsHeads'>
                <h4>{form?.firm ? form?.firm : ''}</h4>
                {companyDetails?.company_code && <span className='__idTag'>ID:{companyDetails?.company_code}</span>}
            </div>

            <div className='__setsContent_prt'>
                <Tab {...profileProps} invoiceBillRaiseClass="settingTbs" />

                {activeTab === 1 && (
                    <FirmProfileDetails data={form} />
                )}

                {activeTab === 2 && (
                    <>
                        <div className='__firmDet_serix_x p-2'>
                            <div className='__setf_brHead'>
                                <h4>Print Number Generation  <span
                                    className={`badge bg-success`}
                                    style={{
                                        marginLeft: "10px",
                                        padding: "5px 10px",
                                        borderRadius: "12px",
                                        fontSize: "12px",
                                        fontWeight: "500",
                                        textTransform: "uppercase",
                                    }}
                                >
                                </span></h4>
                            </div>
                            <div className='__setf_branc_sepBx pt-4 pb-3'>
                                {constant.SERIES_PARAMETER.map(({ id, name, label }) => (
                                    <div key={id} style={{ maxWidth: '280px', width: '100%' }}>
                                        <CommonInput
                                            type="text"
                                            placeholder={label}
                                            label={label}
                                            name={name}
                                            maxLength="10"
                                            onInput={utils.maxLengthCheck}
                                            value={formValue?.[name] || ''}
                                            settingIcon={true}
                                            onClick={(e) => handleInvoiceFunctionality(e, name, id)}
                                            isSettingHnadle={(e) => handleInvoiceFunctionality(e, name, id)}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </>
                )}

                {activeTab === 3 && (
                    <FirmDetailsBankSection />
                )}
            </div>

            {isOpenInvoiceSeries?.action && <FirmSeriesModal {...isInvoiceSeriesModalProps} />}
            {showAddNewInvoiceSeries && <AddNewFirmSeriesModal {...addNewSeriesInvoiceModalProps} />}
        </div>
    )
}

export default FirmDetails